import { SanitizeUrlPipeModule } from './../../pipes/bypass-sanitize-url/bypass-sanitize-url.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PdfViewerComponent } from './pdf-viewer.component';

@NgModule({
    imports: [CommonModule, SanitizeUrlPipeModule],
    exports: [PdfViewerComponent],
    declarations: [
        PdfViewerComponent,
    ],
    providers: [],
})
export class PdfViewerModule { }
